export enum Methods {
  GET = "get",
  POST = "post",
  PUT = "put",
  DEL = "delete",
}

export type ApiMapValueType = {
  url: string;
  method: Methods;
  noAuthHeader?: boolean;
  noCredentials?: boolean;
  mock?: any;
};

export type ApiMapType = {
  [key: string]: ApiMapValueType;
};

export type ApiParamsType = {
  key: ApiMapKeys;
  params?: any;
  data?: any;
  queryParams?: any;
  otherApiConfig?: ApiMapValueType;
  extraHeader?: any;
  mock?: any;
};

export type ApiSearchResult<T> = {
  data: T[];
  meta: { totalRowCount: number };
};

export type ApiSearchQueryParams = {
  page?: number;
  pageSize?: number;
  orderBy?: string;
  orderDirection?: "asc" | "desc";
  search?: string;
};

export type ApiResponseType<T = any> = {
  data: T;
  status: number;
};

export default class ApiException extends Error {
  status!: boolean;
  message: string;
  data: { message: string; detail: string; statusCode: number };
  statusCode?: number;
}
